import { z } from "zod";
import {
  scopeFilterSearchDefaults,
  scopeFilterSearchSchema,
} from "@/components/custom/resources/scope-filter";

export const USER_SOURCES_ROUTE_ID =
  "/_authenticated/orgs/$organizationId/projects/$projectId/user-sources" as const;

export const userSourcesSearchSchema = z.object({
  create: z.boolean().catch(false).default(false),
  ...scopeFilterSearchSchema.shape,
});

export type UserSourcesSearch = z.infer<typeof userSourcesSearchSchema>;

export const userSourcesSearchDefaults: UserSourcesSearch = {
  create: false,
  ...scopeFilterSearchDefaults,
};
